export const RewardDecisionEN = {
    "decisions": {
        "headingLabel": "Decisions",
        "generalInformation": "General information",
        "header": {
            "addDisciplineDecision": "Add Discipline Decision",
            "updateDisciplineDecision": "Update Discipline Decision",
            "detailDisciplineDecision": "Detail Discipline Decision",
            "addRewardDecision": "Add Reward Decision",
            "updateRewardDecision": "Update Reward Decision",
            "detailRewardDecision": "Detail Reward Decision",
        },
        "placeholder": {
            "no": "QD001",
            "decisionDate": "DD-MM-YYYY",
            "decisionMaker": "Type decision maker",
            "validityDate": "DD-MM-YYYY",
            "description": "Type description",
            "typeReward": "Choose reward type",
            "amount": "1,000,000",
            "paymentType": "Choose payment type",
            "reasonReward": "Choose reason reward",
            "approve": "Choose approve",
            "employeeReward": "Department, Job position, Job title, Employee, ...",
            "typeDiscipline": "Choose type"
        },
        "label": {
            "no": "Decision no",
            "decisionDate": "Decision date",
            "decisionMaker": "Decision maker",
            "validityDate": "Validity date",
            "description": "Description",
            "type": "Type",
            "amount": "Amount",
            "paymentType": "Payment type",
            "reasonReward": "Reason",
            "approve": "Approve",
            "employeeReward": "Reward employee",
            "status": "Status",
            "employeeDiscipline": "Discipline employee"
        },
        "type": {
            "reward": {
                "heading": "Reward decision",
                "paid": "Paid",
                "addToSalary": "Add to salary",
                "department": "Department",
                "position": "Position",
                "employee": "Employee",
                "validate": {
                    "employeeReward": "Employee reward not provided",
                    "validityDate": "Validity date not provided",
                    "decisionDate": "Decision date not provided",
                    "decisionNo": "Decision no not provided",
                    "decisionMaker": "Decision maker not provided",
                    "typeReward": "Type reward not provided",
                    "amount": "Amount not provided",
                    "paymentType": "Payment type not provided"
                }
            },
            "discipline": {
                "heading": "Labor discipline decision"
            }
        },
        "rule": {
            "decisionNo" : "Please enter the decision number!",
            "decisionDate": "Please enter the decision date!",
            "validityDate": "Please enter the validity date!",
            "reprimandMethod": "Please choose a discipline method!",
            "disciplineEmployee": "Please choose discipline staff!",
            "rewardMethod": "Please choose a reward method!",
            "rewardEmployee": "Please choose reward staff!",
        }
    }
}